import React from "react";

import { Container, Stack } from "@mui/material";

import { footerPaddingBottom } from "../global/Footer";

const PageContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Container sx={{ paddingBottom: footerPaddingBottom, bgcolor: "background.default" }} maxWidth={false}>
      <Stack spacing={3} sx={{ paddingTop: "22px" }}>
        {children}
      </Stack>
    </Container>
  );
};

export default PageContainer;
